import { render } from "./OapScroller.vue?vue&type=template&id=e871c4c4"
import script from "./OapScroller.vue?vue&type=script&lang=js"
export * from "./OapScroller.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__